// extracted by mini-css-extract-plugin
export default {"brojZahtevaContainer":"ProductionCodeRequestForm_brojZahtevaContainer__fsbqe","brojZahtevaLabel":"ProductionCodeRequestForm_brojZahtevaLabel__4ifmQ"};